const state = {
  today: new Date()
}

const actions = {
  YYYYMMDD (context, options) {
    let {
      date,
      separator = '-'
    } = options
    date = new Date(date)

    const yyyy = date.getFullYear()
    let mm = date.getMonth() + 1 // Months start at 0!
    let dd = date.getDate()

    if (dd < 10) dd = '0' + dd
    if (mm < 10) mm = '0' + mm

    date = yyyy + separator + mm + separator + dd

    return date
  },

  DDMMYYYY (context, options) {
    let {
      date,
      separator = '/'
    } = options
    date = new Date(date)

    const yyyy = date.getFullYear()
    let mm = date.getMonth() + 1 // Months start at 0!
    let dd = date.getDate()

    if (dd < 10) dd = '0' + dd
    if (mm < 10) mm = '0' + mm

    date = dd + separator + mm + separator + yyyy

    return date
  },

  COMMON_DATE (context, options) {
    let {
      date,
      useSecond = false
    } = options
    date = new Date(date)

    let second = ''

    const monthNames = {
      id: [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember'
      ]
    }

    if (useSecond) {
      second = ' - ' +
        ('00' + date.getHours()).slice(-2) + ':' +
        ('00' + date.getMinutes()).slice(-2) + ':' +
        ('00' + date.getSeconds()).slice(-2)
    }

    date = ('00' + date.getDate()).slice(-2) + ' ' +
      (monthNames[context.state.lang][date.getMonth()]) + ' ' +
      date.getFullYear() + second

    return date
  }
}

export default {
  namespaced: true,
  state,
  actions
}
